import { WorkOrderField } from '@atom/types/work';

import classes from './workOrderFields.module.css';

const SUMMARY_FIELD_WIDTH = '32rem';

type WorkOrderSummaryProps = {
  field: WorkOrderField;
  width?: string;
};

const WorkOrderSummary = ({
  field,
  width = SUMMARY_FIELD_WIDTH,
}: WorkOrderSummaryProps) => {
  return (
    <div className={classes.fieldSummary} style={{ width }}>
      <div className={classes.fieldSummaryTitle}>{field.title}</div>
      <div className={classes.fieldSummaryValue}>{field.value}</div>
    </div>
  );
};

export default WorkOrderSummary;
